<template>
  <v-fab-transition>
    <v-btn
      v-if="showScrollTop"
      position="fixed"
      height="36"
      width="36"
      class="scroll-top-button sz-primary-grey--text f-14 deg-180"
      color="white"
      icon="$arrowDown"
      variant="flat"
      @click="scrollTop"
    />
  </v-fab-transition>
</template>

<script>
import { useGoTo } from 'vuetify';

export default {
    name: 'ScrollTopButton',
    setup () {
        const goTo = useGoTo();
        return { goTo };
    },
    data () {
        return {
            showScrollTop: false
        };
    },
    created () {
        window.onscroll = () => {
            this.showScrollTop = window.pageYOffset >= window.innerHeight;
        };
    },
    beforeDestroy () {
        window.onscroll = null;
    },
    methods: {
        scrollTop () {
            this.goTo('body', {
                easing: 'easeInQuad'
            });
        }
    }
};
</script>

<style lang="scss">
.scroll-top-button {
  right: 26px;
  bottom: 120px;
}
</style>
